import React, { Component } from "react";
import {
  NavLink,
  Link
} from "react-router-dom";

export default class Navigation extends Component {
  render() {
    return (
      <nav className='navbar navbar-expand-lg'>
        <div className='container navBucket'>
          <NavLink className='navbar-brand text-logo' to='/'>
            <span className="logo-text">
              <span className="logo-pandemic">Pandemic</span>
              <span className="logo-relief">Relief</span>
              <span className="logo-connect">Connect</span>
            </span>
          </NavLink>

          <div className='navbar-collapse collapse'>
            <ul className='navbar-nav ml-auto'>
              <li className='nav-item'>
                <NavLink className='nav-link' to='/'>
                  Home
                </NavLink>
              </li>
              <li className='nav-item'>
                <NavLink className='nav-link' to='/donate'>
                  Donate
                </NavLink>
              </li>
              <li className='nav-item'>
                <NavLink className='nav-link' to='/about'>
                  About Us
                </NavLink>
              </li>
              <li className='nav-item'>
                <NavLink className='nav-link' to='/contact'>
                  Contact Us
                </NavLink>
              </li>
            </ul>
            <div
              className='navbar-nav ml-5 btn-group'
              role='group'
              aria-label='Basic example'>
              <Link to='/login' className='btn btn-danger'>
                Login
              </Link>
              <Link to='/register' className='btn btn-danger btnReg'>
                Register
              </Link>
            </div>
            <span className='btn bgn-default btnReg'>
              <NavLink to='/dev-status'>
                Dev Status
              </NavLink>
            </span>
          </div>
        </div>
      </nav>
    );
  }
}
